"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProjectProgramApi = void 0;
exports.createProjectProgramApi = (axios) => ({
    listProjectPrograms(props) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get(`/project/${props.projectId}/programs`)).data;
        });
    },
    createProjectProgram({ projectId, programId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.post(`/project/${projectId}/program/${programId}`))
                .data;
        });
    },
    deleteProjectProgram({ projectId, programId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield axios.delete(`/project/${projectId}/program/${programId}`);
        });
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdFByb2dyYW1BcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBpL3Byb2plY3RQcm9ncmFtQXBpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUdhLFFBQUEsdUJBQXVCLEdBQUcsQ0FBQyxLQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzFELG1CQUFtQixDQUFDLEtBRXpCOztZQUNDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxHQUFHLENBQUMsWUFBWSxLQUFLLENBQUMsU0FBUyxXQUFXLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztRQUN4RSxDQUFDO0tBQUE7SUFFSyxvQkFBb0IsQ0FBQyxFQUN6QixTQUFTLEVBQ1QsU0FBUyxHQUlWOztZQUNDLE9BQU8sQ0FBQyxNQUFNLEtBQUssQ0FBQyxJQUFJLENBQUMsWUFBWSxTQUFTLFlBQVksU0FBUyxFQUFFLENBQUMsQ0FBQztpQkFDcEUsSUFBSSxDQUFDO1FBQ1YsQ0FBQztLQUFBO0lBRUssb0JBQW9CLENBQUMsRUFDekIsU0FBUyxFQUNULFNBQVMsR0FJVjs7WUFDQyxNQUFNLEtBQUssQ0FBQyxNQUFNLENBQUMsWUFBWSxTQUFTLFlBQVksU0FBUyxFQUFFLENBQUMsQ0FBQztRQUNuRSxDQUFDO0tBQUE7Q0FDRixDQUFDLENBQUMifQ==